module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#mynews",
      toString: function () {
        return this.url;
      }
    }